export const mapTransactionHistoryModel = (historyFromApi) => {
  return {
    address: historyFromApi.get("address"),
    avatar: historyFromApi.get("avatar"),
    blue_check: historyFromApi.get("blue_check"),
    memories: historyFromApi.get("memories").toJS(),
    post_comment: historyFromApi.get("post_comment"),
    post_photo: historyFromApi.get("post_photo"),
    slug: historyFromApi.get("slug"),
    timestamp: historyFromApi.get("timestamp"),
    uid: historyFromApi.get("uid"),
    txHash: historyFromApi.get("txHash"),
  };
};
